import React, { useMemo } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { RiskPoolPolicySolution } from '../../../../_types/solution';
import { translate as t } from 'hooks/useTranslations';
import GridSection, { ColumnDef } from 'components/_layouts/GridSection';

interface ViewProps {
  solutions: RiskPoolPolicySolution[];
  isLoading: boolean;
}

const View: React.FC<ViewProps> = ({ solutions, isLoading }) => {
  const enabledSolutions = useMemo(() => solutions.filter(s => s.state === 'ENABLED'), [solutions]);

  const columns: ColumnDef = useMemo(() => ({
    manualName: {
      header: t('manageSolutions.riskPool.policy.manual'),
      flex: 1,
    },
    orgName: {
      header: t('manageSolutions.riskPool.policy.organization'),
      flex: 1,
    },
  }), []);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (enabledSolutions.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="bodyMd" color="text.secondary">
          {t('manageSolutions.riskPool.policy.noManualsEnabled')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <GridSection
        columns={columns}
        data={enabledSolutions}
        isLoading={isLoading}
        gridKey="risk-pool-view-grid"
        gridProps={{
          getRowId: (row: RiskPoolPolicySolution) => row.manualId,
          rowHeight: 48,
          hideFooter: true
        }}
      />
    </Box>
  );
};

export default View;
